<template>
  <div class="bg-set-dialog-wrap padding12">
    <!-- 图片设置 -->
    <div class="bg-set-dialog">
      <div class="mb16">名称</div>
      <div class="el-input">
        <input class="el-input__inner" type="text" style="width: 100%; height: 32px" v-model="tabsItem.name" />
        <p class="mt12">默认状态图标</p>
        <img-icon-upload
          class="mt4"
          :imgSrc.sync="tabsItem.iconSrc"
          :iconType.sync="tabsItem.iconType"
          :iconColor.sync="tabsItem.iconColor"
        />
        <p class="mt12">悬停状态图标</p>
        <img-icon-upload
          class="mt4"
          :imgSrc.sync="tabsItem.hoverIconSrc"
          :iconType.sync="tabsItem.hoverIconType"
          :iconColor.sync="tabsItem.hoverIconColor"
        />
        <p class="mt12">选中状态图标</p>
        <img-icon-upload
          class="mt4"
          :imgSrc.sync="tabsItem.activeIconSrc"
          :iconType.sync="tabsItem.activeIconType"
          :iconColor.sync="tabsItem.activeIconColor"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: var(--dialogShade);
  z-index: 9999;
}
.bg-set-dialog {
  position: absolute;
  top: 50%;
  left: 12px;
  width: 236px;
  padding: 12px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}
</style>

<script>
export default {
  name: "tabs-img-upload-dialog",
  props: {
    tabsActiveIndex: {
      type: Number,
      default: 0
    },
    tabsItem: {
      type: Object,
      default: {}
    },
    updateName: {
      type: String,
      default: "tabsList"
    }
  },
  watch: {
    tabsItem: {
      handler(newVal,oldVal) {
        console.log("newVal", newVal)
        let result = JSON.parse(JSON.stringify(newVal))
        result.content = result.name
        const param = {
          ...this.ids,
          option_name: `${this.updateName}.${this.tabsActiveIndex}`,
          option_val: result
        }
        // 不生效 换方式处理
        // if(newVal.iconSrc && newVal.iconSrc !== oldVal.iconSrc){
        //   // 一帆要求上传图标后关闭弹框
        //   this.$emit("addImg")
        // }
        // if(newVal.hoverIconSrc && newVal.hoverIconSrc !== oldVal.hoverIconSrc){
        //   this.$emit("addImg")
        // }
        // if(newVal.activeIconSrc && newVal.activeIconSrc !== oldVal.activeIconSrc){
        //   this.$emit("addImg")
        // }
        this.$store.dispatch(this.request_prefix + "/changeOptions", param)
      },
      deep: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  mounted() {},
  methods: {}
}
</script>
